import TODO from './todo'
import USER from './user'

export const ACTIONS = {
  ...TODO,
  ...USER
}
